<template>
  <main>
    <div class="row">
      <div class="col-md-12">
        <TopTemplate>
          <template #left-element>
            <h3>{{ $t("title.addTeacher")}}</h3> 

          </template>

          <template #right-element>
            <router-link
              :to="{ name: 'teacher_list' }"
              class="btn btn-outline-primary button"
              :disabled="loading"
            >
              <i class="arrow left" />
              {{ $t("button.retour") }}
            </router-link>
          </template>
        </TopTemplate>

        <div v-if="is_created" class="alert alert-success" role="alert">
          L'enseignant
          <router-link
            class="success_msg"
            :to="{ name: 'DetailTeacher', params: { id: teacher.id } }"
          >
            {{ teacher.fullName }} </router-link
          >a été ajouté avec succés !
        </div>
        <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
          <div class="spinner-border text-info" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <form
        v-else
          class="add-teacher"
          novalidate
          @submit.prevent="onSubmitCreateTeacher"
        >
          <div class="general-info">
            <div class="accordSid" @click="toggleAccInfo()">
              <h3>{{ $t("title.infoGeneral") }}</h3>
              <div class="icons-wrapper">
                <i v-if="show1" class="icon-Minus color-green" />
                <i v-else class="icon-Add color-green" />
              </div>
            </div>

            <div v-if="show1" class="panel">
              <div class="row">
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                      <div class="simple-input">
                        <label class="label">
                          {{ $t("teacher.form.firstName") }}
                          <sup>*</sup>
                        </label>
                        <div>
                          <input
                            v-model="teacher.first_name"
                            type="text"
                            class="form-control"
                            :class="
                              v$.teacher.first_name.$error ? 'is-invalid' : ''
                            "
                          />
                          <span
                            v-if="v$.teacher.first_name.$error"
                            class="invalid-feedback"
                          >
                            {{ v$.teacher.first_name.$errors[0].$message }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                      <div class="simple-input">
                        <label class="label">
                          {{ $t("teacher.form.lastName") }}
                          <sup>*</sup>
                        </label>
                        <div>
                          <input
                            v-model="teacher.last_name"
                            type="text"
                            class="form-control"
                            :class="
                              v$.teacher.last_name.$error ? 'is-invalid' : ''
                            "
                          />
                          <span
                            v-if="v$.teacher.last_name.$error"
                            class="invalid-feedback"
                          >
                            {{ v$.teacher.last_name.$errors[0].$message }}
                          </span>
                        </div>
                      </div>
                    </div>






                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                      <div class="simple-input">
                        <label class="label">
                          {{ $t("teacher.form.phone") }}
                          <sup>*</sup>
                        </label>
                        <div>
                          <input
                            v-model="teacher.phone"
                            type="text"
                            class="form-control"
                            @input="formatPhoneNumber"
                            :class="{
                              'is-invalid':
                                v$.teacher.phone.$error ||
                                (!validNumber && isValidate),
                            }"

                          />
                          <span
                            v-if="v$.teacher.phone.$error"
                            class="invalid-feedback"
                          >
                            {{ v$.teacher.phone.$errors[0].$message }}
                          </span>
                          <span
                            v-if="
                              !validNumber &&
                              isValidate &&
                              !v$.teacher.phone.$error
                            "
                            class="invalid-feedback"
                            >{{ $t("validation.isPhone") }}</span>
                          
                          <span
                            v-if="messageErrorPhone"
                            class="invalid-feedback"
                            >{{ messageErrorPhone }}</span>
                        </div>
                      </div>
                    </div>



                    
                    
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                      <div class="simple-input">
                        <label class="label">
                          {{ $t("teacher.form.email") }}
                        </label>
                        <div>
                          <input
                            v-model="teacher.email"
                            type="email"
                            class="form-control"
                            :class="v$.teacher.email.$error ? 'is-invalid' : ''"
                          />
                          <span
                            v-if="v$.teacher.email.$error"
                            class="invalid-feedback"
                            >{{ v$.teacher.email.email.$message }}</span
                          >
                          <span
                            v-if="messageErrorEmail"
                            class="invalid-feedback"
                            >{{ messageErrorEmail }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                      <div class="simple-input">
                        <label class="label">
                          {{ $t("teacher.form.address") }}
                        </label>
                        <div>
                          <input
                            v-model="teacher.address"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12 simple-input">
                      <label class="label">{{
                        $t("teacher.form.emploi")
                      }}</label>
                      <label
                        class="input-image"
                        for="otherDoc"
                        @change="onFileChange"
                      >
                        <div class="file-name">
                          <span class="justify--" v-if="teacher.timetable">
                            {{ teacher.timetable }}
                          </span>
                          <span class="justify--- err article" v-else>
                            {{ $t("info.downloadDocs") }}
                          </span>
                        </div>
                        <div class="icon-upload">
                          <img src="../../assets/icons/VectorMsg.svg" />
                        </div>
                        <input
                          id="otherDoc"
                          type="file"
                          class="d-none"
                          accept=".pdf"
                          tabindex="-1"
                          @change="onFileInputChange"
                          ref="fileInput"
                        />
                        
                      </label>
                      <span class="notif-pdf">{{ $t("info.authFilePdf") }}</span>

                    </div>
                  
              </div>
            </div>
          </div>
          <div class="general-info duplicator">
            <div class="accordSid" @click="toggleAccNiv()">
              <h3>{{ $t("title.selectClasses") }}</h3>
              <div class="icons-wrapper">
                <i v-if="show2" class="icon-Minus color-green" />
                <i v-else class="icon-Add color-green" />
              </div>
            </div>

            <div v-if="show2" class="panel">
              <div
                v-for="(item, index) in teacher.classes"
                :key="index"
                class="row align-items-center duplicator__ex"
              >
                <div :class="existRemove ? 'col-xl-5' : 'col-xl-6'">
                  <div class="simple-input simple-select">
                    <label class="label">
                      {{ $t("teacher.form.class") }}
                    </label>
                    <v-select
                      v-model="teacher.classes[index].id_class"
                      :options="classesList"
                      :searchable="true"
                      label="name"
                      class="form-control"
                      :reduce="(option) => option"
                      :scrollable="true"
                      @update:modelValue="ChangeClass($event, index)"
                    >
                    <template #no-options="{ search, searching, loading }">
                        <div
                          v-if="!loading"
                          class="card mt-2 text-center d-block pt-2 pb-2"
                        >
                          {{ $t("common.emptysearchClasse") }}
                        </div>
                        <div
                          v-else
                          class="card mt-2 text-center d-block pt-2 pb-24"
                        >
                          <div class="spinner-border text-info" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
                <div :class="existRemove ? 'col-xl-5' : 'col-xl-6'">
                  <div class="simple-input simple-select selct-multip">
                    <label class="label">
                      {{ $t("teacher.form.courses") }}
                    </label>
                    <v-select
                      v-model="teacher.classes[index].courses"
                      :options="coursesList[index]"
                      :searchable="true"
                      label="name"
                      class="form-control"
                      :reduce="(option) => option"
                      :scrollable="true"
                      multiple
                      :class="{ disabled: !teacher.classes[index].id_class }"
                      :disabled="!teacher.classes[index].id_class"
                    >
                    
                       <template #no-options="{search, searching, loading}">
                  <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">{{ $t("common.emptysearchCourse") }}</div>

                  <div v-else class="card mt-2 text-center d-block pt-2 pb-2">
                    <div class="spinner-border text-info" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </template>
                    </v-select>
                  </div>
                </div>
                <div class="simple-input last-input-modif col-md-3 col-6">
                  <div class="buttons-wrapper">
                    <i
                      v-if="teacher.classes.length > 1"
                      class="icon-trash"
                      @click="removeItem(index)"
                    />
                    <!-- <i
                      @click="addMore()"
                      class="icon-Add"
                      v-if="index === teacher.classes.length - 1"
                      ></i> -->
                  </div>
                </div>
                <div
                  v-if="index === teacher.classes.length - 1"
                  class="col-md-12 btn-add"
                >
                  <button class="btn button btn-primary" @click="addMore()">
                    <i class="icon-Add" /> {{ $t("button.add") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 buttons">
            <div class="button-right d-flex justify-content-end mb-4">
              <button
                type="submit"
                class="btn button btn-primary"
                :disabled="isSubmitted"
              >
                <i class="icon-Check" />
                {{ $t("button.envoi") }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import vSelect from "vue-select";
import Form from "../../core/Form";
import useValidate from "@vuelidate/core";
import {
  required,
  maxLength,
  helpers,
  email,
  numeric,
} from "@vuelidate/validators";
import TeacherService from "../../services/teacher.service";
import ClasseService from "../../services/classe.service";
import CoursesService from "../../services/courses.service";
import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { parsePhoneNumberFromString, isValidNumber } from "libphonenumber-js";
const isPhone = helpers.regex(/^[0-9]{8}/); //phone valid
function isValidPhone(value) {
  console.log(value);
  const phoneNumber = parsePhoneNumberFromString(value);
  console.log(isValidNumber("+216", phoneNumber));
  return isValidNumber("+216", phoneNumber);
}
export default {
  name: "AddTeacher",
  components: {
    TopTemplate,
    Datepicker,
    "v-select": vSelect,
  },
  setup() {
    // In case of a range picker, you'll receive [Date, Date]

    const format = (due_date) => {
      const day = due_date.getDate();
      const month = due_date.getMonth() + 1;
      const year = due_date.getFullYear();
      if (day <= 9) {
        return `0${day}/${month}/${year}`;
      } else if (day > 9) {
        return `${day}/${month}/${year}`;
      }
      if (month <= 9) {
        return `${day}/0${month}/${year}`;
      } else {
        return `${day}/${month}/${year}`;
      }
    };

    return {
      format,
    };
  },
  data() {
    return {
      isValidPhoneNumber: true,
      validNumber: true,
      isSubmitted: false,
      isValidate: false,
      existRemove: false,
      v$: useValidate(),
      teacher: new Form({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        address: "",
        id: "",
        fullName: "",
        classes: [
          {
            courses: [],
            id_class: null,
            id_course: [],
          },
        ],
      }),
      params: {
        class_school_id: [],
        course_id: [],
        sort: "created_at",
        order: false,
      },
      loading: false,
      classesList: [],
      coursesList: [],
      loadFilter: false,
      messageErrorEmail: null,
      messageErrorPhone: null,
      messageErrorClasse: null,
      disabled: true,
      show1: true,
      show2: true,
      is_created: false,
      requiredPhoneLength: 8,
      formattedPhoneNumber: "",
      namedoc: null,
      file: null,
    };
  },
  created() {
    this.getFiltre();
  },
  validations() {
    return {
      teacher: {
        first_name: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
        },
        last_name: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
        },
        email: {
          email: helpers.withMessage(this.$t("validation.email"), email),
        },
        phone: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
        },
      },
    };
  },

  methods: {
    onFileInputChange(event) {
    const input = event.target;
    if (input.files && input.files.length > 0) {
      const fileName = input.files[0].name;
      input.value = fileName;  // Mettre à jour la valeur de l'attribut "value"
    }
  },
      onFileChange(e) {
      this.file = e.target.files[0];
      this.namedoc = this.file.name;
      this.teacher.timetable = this.namedoc;
    },
    formatPhoneNumber() {
      this.messageErrorPhone = null;
      const phoneNumber = parsePhoneNumberFromString(this.teacher.phone, "TN");
      if (this.teacher.phone) {
        if (!phoneNumber) {
          this.validNumber = false;
          return;
        }
        this.validNumber = isValidNumber(phoneNumber.number);
        if (phoneNumber) {
          this.teacher.phone = phoneNumber.formatNational();
        } else if (phoneNumber.length > 2) {
          this.teacher.phone = "";
        }
      }
    },
    toggleAccInfo() {
      this.show1 = !this.show1;
    },
    toggleAccNiv() {
      this.show2 = !this.show2;
    },
    addMore() {
      this.teacher.classes.push({
        courses: [],
        id_class: null,
        id_course: [],
      });
      this.existRemove =true
    },
    removeItem(i) {
      this.teacher.classes = this.teacher.classes.filter(
        (el, index) => index != i
      );
      this.existRemove[i] =false
    },
    getFiltre(i) {
      // this.loading = true;
      //  this.coursesList[i] = [];
      //  this.params.class_school_id= [];
      this.loadFilter = true;
      TeacherService.getFilterCourses({
        params: {
          class_school_id: this.params.class_school_id,
          sort: this.params.sort,
          order: this.params.order,
        },
      })
        .then(
          (response) => {
            this.classesList = _.orderBy(response.data.classes, "name");
            this.coursesList[i] = _.orderBy(response.data.courses, "name");
          },
          (error) => {
            this.loading = false;
          }
        )
        .finally(() => {
          this.loadFilter = false;
        });
    },
    ChangeClass(e, i) {
      this.teacher.classes[i].courses = null;
      this.coursesList[i] = [];
      if (e != null) {
        this.params.class_school_id = [];
        this.params.class_school_id = e;
      } else {
        this.params.class_school_id = [];
      }
      this.loadMatier(e, i);
      // this.getFiltre(i);
    },
    loadMatier(classe, index) {
      if (classe) this.coursesList[index] = _.orderBy(classe.courses, "name");
    },
    createTeacher(data) {
      TeacherService.create(data)
        .then((response) => {
          this.is_created = true;
          this.scrollToTop();
          this.teacher.id = response.data.id;
          this.teacher.fullName = `${response.data.last_name} ${response.data.first_name} `;
          this.$router.push({ name: "teacher_list" });
        })
        .then(() => {
          this.$nextTick(() => {
            this.resetForm();
            setTimeout(() => {
              this.v$.$reset();
            }, 0);
          });
        })
        .catch((error) => {
            this.messageErrorEmail = error.response.data.errors.email ? this.$t('error.uniqueEmail'):false;
            this.messageErrorPhone = error.response.data.errors.phone ? this.$t('error.existPhone'):false;
            if (this.teacher.classes.length === 0) {
              this.teacher.classes.push({
                courses: [],
                id_class: null,
                id_course: [],
              });
            }
         
          this.is_created = false;
         
          this.scrollToTop();
        }).finally(()=>{ this.loading = false;});
    },
    onSubmitCreateTeacher() {
      this.isValidate = true;
      this.v$.$validate();
      this.$nextTick(() => {
        if (document.querySelector(".is-invalid")) {
          //this.candidature.edit_candidat = true;
          this.show1 = true;
          this.show2 = true;

          let domRect = document
            .querySelector(".is-invalid")
            .getBoundingClientRect();
          window.scrollTo({
            left: domRect.left + document.documentElement.scrollLeft,
            top: domRect.top + document.documentElement.scrollTop - 90,
            behavior: "smooth",
          });
        }
      });

      if (!this.v$.$error && this.validNumber) {


        // this.teacher.classes.map((item, index) => {
        //   if (item.id_class) {
        //     item.id_class = item.id_class.id;
        //   } else {
        //     this.teacher.classes.splice(index, 1);
        //   }
        // });

const formattedClasses = this.teacher.classes.map((item) => {
  if (item.id_class) {
    return {
      ...item,
      id_class: item.id_class.id,
    };
  }
  return item;
});





        /*   const data = {
          first_name: this.teacher.first_name,
          last_name: this.teacher.last_name,
          email: this.teacher.email,
          address: this.teacher.address,
          phone: this.teacher.phone,
          classes: this.teacher.classes,
        }; */
        let formData = new FormData();
        let phone = this.teacher.phone.replaceAll(" ", "");
        formData.append("_method", "POST");
        formData.append("first_name", this.teacher.first_name);
        formData.append("last_name", this.teacher.last_name);
        formData.append("address", this.teacher.address);
        formData.append("phone", phone);
        formData.append("email", this.teacher.email);
        // formData.append("classes", JSON.stringify(this.teacher.classes));
         formData.append("classes", JSON.stringify(formattedClasses));
        if (this.file) {
          formData.append("timetable", this.file);
        }
        console.log(formData)
        this.firstname = this.teacher.first_name;
        this.lastname = this.teacher.last_name;

        this.createTeacher(formData);
      } else {
        this.loading = false;
        this.is_created = false;
        this.scrollToTop();
      }
      this.isSubmitted = false;
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },

    ChangeDis() {
      this.disabled = false;
    },
    resetForm() {
      this.teacher.first_name = "";
      this.teacher.last_name = "";
      this.teacher.email = "";
      this.teacher.phone = "";
      this.teacher.address = "";
      this.teacher.classes.forEach((cl) => {
        cl.id_class = "";
        cl.courses = "";
      });
    },
  },
};
</script>

<style>
#vs1__listbox {
  max-height: 150px;
}
#vs3__listbox {
  max-height: 150px;
}
.add-teacher .invalid-feedback {
  display: block;
}
.simple-input {
  position: relative;
}

.invalid-add-teacher {
  position: absolute;
  top: 100%;
  left: 0;
  margin: 0;
}
</style>

